import { isEqual } from "lodash";
import { Patch } from "rfc6902";
import { getActivePatchResult } from "./getActivePatchResult";
import { getVariantPatchContext } from "./getVariantPatchContext";
import { TlfContextProps, UPDATE_TLF } from "./interface";
import { tlf_updateTlf } from "./tlf_updateTlf";

interface CommittedPatch {
  state: TlfContextProps;
  catalog: Record<string, Patch> | null;
}

/**
 * Commits the active patch into the catalog and TLF undo history.
 *
 * @param state - Current TLF context state
 * @param calledFrom - Reducer action origin for history tracking
 * @returns Updated state and the committed catalog, or null catalog when invalid
 */
export const commitActivePatch = (state: TlfContextProps, calledFrom: string): CommittedPatch => {
  const { information } = getVariantPatchContext(state);
  const activeName = state.activeVariantPatchName;
  if (information === null || activeName === null) {
    return { state, catalog: information?.allVariantPatches ?? {} };
  }
  const result = getActivePatchResult(state, getVariantPatchContext(state));
  if (result === null || result.invalidOps.length > 0) return { state, catalog: null };
  const catalog = { ...information.allVariantPatches, [activeName]: result.patch };
  if (isEqual(catalog, information.allVariantPatches)) return { state, catalog };
  return {
    state: tlf_updateTlf(state, {
      operation: UPDATE_TLF,
      tlfData: { allVariantPatches: catalog },
      calledFrom,
    }),
    catalog,
  };
};
